import styled from 'styled-components'

import { FlexCentered } from 'components/common/genericStyles'
import { Color } from 'constants/color'

export const CrossImageContainer = styled.div`
    ${FlexCentered}
    width: 2em;
    height: 2em;

    background: ${Color.black};
    border-radius: 50%;

    position: absolute;
    bottom: 10%;
    right: 30%;
    z-index: 12;
`

export const CrossImage = styled.img`
    max-width: 100%;
    max-height: 100%;

    cursor: pointer;
`
